<template>
  <fieldset :class="$style.fieldset">
    <legend :class="$style.legend">
      <slot name="legend" />
    </legend>
    <slot />
  </fieldset>
</template>

<style lang="scss" module>
@use '@design' as *;

.fieldset {
  padding: $size-grid-padding * 0.25 $size-grid-padding $size-grid-padding;
  margin: 0 0 $size-grid-padding;

  // border: $size-input-border solid #d0d0d0;

  > :first-child {
    margin-top: 0;
  }

  > :last-child {
    margin-bottom: 0;
  }
}

.legend {
  @include typography-got-rhythm(0);

  @extend %font-heading;

  padding: 0 $size-grid-padding * 0.5;
  margin-left: $size-grid-padding * -0.5;
  line-height: 0;
}
</style>
